<template>
	<b-modal v-model="isChangeLogModalOpen" title="Log de Alterações" hide-footer size="lg">
		<div v-for="({commit, bookings, items}, i) in changeLogs" :key="1+i*7" class="change-log">
			<div class="author">
				<span>
					<b>Alteração {{commit.commit.id.majorId}} feita por:</b>
					<div>{{commit.commit.author}}</div>
				</span>
				<b class="log-date">{{formatDate(commit.commit.commitDate)}}</b>
			</div>

			<ul class="changes">
				<li v-for="(change, i) in commit.changes" :key="i+(1*1000)">
					<b>{{propertyLabel(change.propertyName)}}</b> alterado
					de <b>"{{valueFormat(change.left, change.propertyName)}}"</b> para <b>"{{valueFormat(change.right, change.propertyName)}}"</b>
				</li>
				<li v-for="(change, i) in bookingChanges(bookings)" :key="commit.changes.length + i">
					<div><b>{{propertyLabel(change.propertyName)}}</b> do booking <b>{{change.bookingNumber}}</b> alterado de <b>"{{valueFormat(change.left, change.propertyName)}}"</b> para <b>"{{valueFormat(change.right, change.propertyName)}}"</b></div>
				</li>
				<li v-for="(change, i) in itemChanges(items)" :key="commit.changes.length*2 + i">
					<div><b>{{propertyLabel(change.propertyName)}}</b> do item do booking <b>{{change.bookingNumber}}</b> alterado De <b>"{{valueFormat(change.left, change.propertyName)}}"</b> para <b>"{{valueFormat(change.right, change.propertyName)}}"</b></div>
				</li>
			</ul>

			<hr v-if="i < changeLogs.length - 1"/>
		</div>
	</b-modal>
</template>

<script>
import moment from 'moment';
import ServiceOrderService from '../../service/ServiceOrderService';
import { fetchModel, formatLocalDateTime } from '../../utils';

export default {
	data() {
		return {
			isChangeLogModalOpen: false,
			changeLogs: [],
			service: new ServiceOrderService(),
		};
	},
	methods: {
		async open(serviceOrder) {
      this.serviceOrder = serviceOrder;
			this.changeLogs = await this.fetchChanges(serviceOrder.id);
			this.isChangeLogModalOpen = true;
		},
		async fetchChanges(id) {
			return await fetchModel('log de alterações', () => this.service.fetchChanges(id));
		},
		bookingChanges(bookings) {
			return bookings
        .flatMap(({bookingNumber, service, commit}) => commit.changes.map(c => ({bookingNumber, service, ...c})))
        .filter(c => this.serviceOrder.bookings.some(b => b.booking.bookingNumber === c.bookingNumber && b.guide && b.guide.id === this.$store.state.user.id));
		},
		itemChanges(items) {
			let listItemsChange = items.flatMap(({bookingNumber, commit, providerChange, serviceChange}) => [
				...commit.changes.map(c => ({bookingNumber, ...c})),
				...providerChange ? [{bookingNumber, ...providerChange, propertyName: "provider"}] : [],
				...serviceChange ? [{bookingNumber, ...serviceChange, propertyName: "service"}] : [],
			])
			let currentBookings = this.serviceOrder.bookings.filter(booking => booking.guide && booking.guide.id === this.$store.state.user.id);
			let bookingNumbers = currentBookings.map(currentBooking => currentBooking.booking.bookingNumber);
			listItemsChange = listItemsChange.filter(itemChange => bookingNumbers.some(bookingNumber => bookingNumber === itemChange.bookingNumber));
			return listItemsChange;
		},
		propertyLabel(name) {
			return ({
				plate: "Placa",
				principalPoint: "Ponto Principal",
				pickup: "Pick up",
				pickupPlace: "Local Pick-up",
				dropoffPlace: "Local Drop-off",
				flightNumberInformation: "Voo",
				flightDateInformation: "Data",
				flightTimeInformation: "Hora",
				flightOriginInformation: "Origem",
				flightDestinationInformation: "Destino",
				clientToGuideObs: "Observação do Cliente para o Guia",
        mainGuide: "Guia Principal",
        guide: "Guia",
				duration: "Duração",
				driver: "Motorista",
				provider: 'Fornecedor',
				service: 'Serviço'
			})[name] || name;
		},
		valueFormat(value, propertyName) {
			let formatter = ({
				flightDateInformation: (value) => {
					let date = moment(value, 'YYYY-MM-DD');
					return date.isValid() ? date.format('DD/MM/YYYY') : value;
				},
        mainGuide: x => x && x.name,
        guide: x => x,
				provider: x => x && x.name,
				service: x => x && x.name
			})[propertyName] || (x => x);
			return formatter(value);
		},
		formatDate(date) {
			return formatLocalDateTime(date);
		},
	}
}
</script>

<style scoped>
.author {
	display: flex;
	justify-content: space-between;
}

.changes {
	margin-top: 20px;
}

@media screen and (max-width: 750px) {
	.author {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/os/ChangeLogModal.vue